import { IonButton, IonButtons, IonContent, IonFooter, IonHeader, IonInput, IonItem, IonLabel, IonMenuButton, IonNote, IonPage, IonTitle, IonToolbar, useIonToast } from "@ionic/react"
import { useFormik } from "formik"
import { useHistory, useLocation } from "react-router"
import * as Yup from "yup"
import { User } from "../../dto/user"
import { save } from "./service"

const ProfileForm: React.FC = () => {

  const [toast] = useIonToast()
  const history = useHistory()
  const location = useLocation()
  let userState = location?.state as User

  // useEffect(() => {
  // }, [])

  const onSubmit = async (user: User) => {
    console.log('updatePassword', user)
    await save(user)
    history.replace('/', { refresh: true })

    toast({
      message: "Senha atualizada com sucesso.",
      duration: 1_500,
      position: 'top'
    })
  }

  const requiredError = 'Campo obrigatório'
  const lengthError = 'Mínimo de 4 caracteres'

  let valid: any = {
    name: Yup.string().required(requiredError).min(4, lengthError),
    email: Yup.string().email('Email inválido').required(requiredError),
    password: Yup.string().required(requiredError).min(4, lengthError),
    passwordConfirm: Yup.string().required(requiredError).min(4, lengthError).oneOf([Yup.ref('password')], 'As senhas não são iguais.')
  }

  const formik = useFormik({
    initialValues: userState,
    onSubmit: onSubmit,
    validationSchema: Yup.object().shape(valid),
    validateOnMount: true,
    enableReinitialize: false
  })

  if (!userState || (userState as any).refresh) {
    return <></>
  }

  const buildInput = (label: string, name: string, type: any = 'text', disable: boolean = false) => {
    const val: any = formik.values
    const erros: any = formik.errors
    const msm = erros[name]

    return <IonItem className={`${!msm && 'ion-valid'} ${msm && 'ion-invalid ion-touched'}`}>
      <IonLabel position="stacked">{label}</IonLabel>

      <IonInput
        name={name}
        value={val[name]}
        type={type}
        disabled={disable}
        onIonChange={formik.handleChange}
        onIonBlur={formik.handleBlur}
      />

      {msm &&
        <IonNote slot="error" style={{ color: 'var(--ion-color-danger)', textAlign : 'right', width : '100%',  }}>{msm}</IonNote>
      }
    </IonItem>
  }

  const buildContent = () => {
    return (
      <form onSubmit={formik.handleSubmit} style={{margin:"0.5em"}}>
        {buildInput("Nome", "name", 'text', true)}
        {buildInput("E-mail", "email", "email", true)}
        {buildInput("Senha", "password", "password")}
        {buildInput("Confirmar senha", "passwordConfirm", "password")}
      </form>
    )
  }

  return (
    <IonPage>
      <IonHeader style={{ marginBottom: "1em" }}>
        <IonToolbar>
          <IonButtons slot="start">
            <IonMenuButton />
          </IonButtons>
          <IonTitle style={{marginLeft: "1em"}}>Perfil</IonTitle>
        </IonToolbar>
      </IonHeader>

      <IonContent fullscreen>
        {buildContent()}
      </IonContent>

      <IonFooter>
        <IonToolbar style={{color : 'white'}} >
        
          <IonButtons slot="start">
            <IonButton onClick={() => { 
              history.goBack()
              }} >
              Cancelar
            </IonButton>
          </IonButtons>

          <IonButtons slot="end">

            <IonButton disabled={!formik.isSubmitting && (Array.isArray(formik.errors) || Object.values(formik.errors).toString() !== "")}
              onClick={() => {
                formik.handleSubmit()
              }}>
              Salvar
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonPage>
  )
}

export default ProfileForm
